var img = "data:image/svg+xml,%3csvg width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M35.9082 12.3438L11.9082 36.3438' stroke='%238F8F8F' stroke-width='4' stroke-linecap='round' stroke-linejoin='round'/%3e%3cpath d='M11.9082 12.3438L35.9082 36.3438' stroke='%238F8F8F' stroke-width='4' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/svg%3e";

export { img as default };
//# sourceMappingURL=icon-close.svg.js.map
